import { WidgetRendererBase } from "../widget-renderer-base";
import { IRenderingCommonContext } from "@commonRendering/types";
import { IStoreSubscriptionsRenderingData, IStoreSubscriptionsWidgetData, StoreSubscriptionsWidgetData } from "src/typings/store-subscriptions-widget-data";
import { StoreSubscriptionsWidgetScriptRenderer } from "./store-subscriptions-widget-script-renderer";
import { StoreSubscriptionsStyleRenderer } from "./store-subscriptions-style-renderer";
import { Base64Util } from "src/utils/base64-util";

export class StoreSubscriptionsWidgetRenderer extends WidgetRendererBase<IStoreSubscriptionsWidgetData> {

    private readonly styleRenderer: StoreSubscriptionsStyleRenderer;
    private readonly scriptRenderer: StoreSubscriptionsWidgetScriptRenderer;

    private readonly RENDERING_DATA_ATTRIBUTE = "data-store-subscriptions";

    constructor(renderingCommonContext: IRenderingCommonContext) {
        super(renderingCommonContext);
        this.styleRenderer = new StoreSubscriptionsStyleRenderer(this.styleService);
        this.scriptRenderer = new StoreSubscriptionsWidgetScriptRenderer();
    }

    protected createNewInternal(): HTMLElement {
        return this.createWidgetElement("storeSubscriptionsWidget");
    }

    protected renderInternal(element: HTMLElement, data: IStoreSubscriptionsWidgetData): HTMLElement {
        const previousData = this.getData(element);

        this.setAttributes(element, data);
        this.renderStyles(element, data);
        this.renderScript(element, previousData, data);

        return element;
    }

    private setAttributes(element: HTMLElement, data: IStoreSubscriptionsWidgetData): void {
        const renderingData: IStoreSubscriptionsRenderingData = {
            style: data.style
        };

        const json = Base64Util.serialize(renderingData) || "";
        element.setAttribute(this.RENDERING_DATA_ATTRIBUTE, json);

        if (this.isEditorRendering) {
            element.setAttribute("data-draft", "true");
        }
    }

    private renderScript(element: HTMLElement, previousData: IStoreSubscriptionsWidgetData | null, data: IStoreSubscriptionsWidgetData): void {
        if (StoreSubscriptionsWidgetData.localScriptRerenderNeeded(previousData ?? undefined, data)) {
            this.scriptRenderer.renderCommon(this.renderingCommonContext.renderedDoc);
            this.scriptRenderer.renderLocal(element);
        }
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    protected override cleanupInternal(element: HTMLElement): void {
        // nothing
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    protected override getContentSelectorsInternal(element: HTMLElement): string[] {
        return [`#${element.id}`, `#${element.id} .widget-content`];
    }

    protected override renderStyles(element: HTMLElement, data: IStoreSubscriptionsWidgetData): void {
        this.animationRenderer.setAnimationStyles(element, data.style.animation);
        this.styleRenderer.render(element, data.style);
    }

}
